<template>
  <layout-dashboard-card
    title="총 차량 등록 댓수"
    :value="statRegistered.total[0]"
    prepend-string="오늘"
    append-string="대"
    :icon="icon"
    :width="350"
    :height="180">
    <template v-slot:extension>
      <div class="card-history-list d-flex justify-center">
        <table>
          <tr
            v-for="idx in 3"
            :key="`value_${idx}`">
            <td>{{ idx }}일전</td>
            <td class="card-history-list-value">{{ statRegistered.total[idx] }}대</td>
          </tr>
        </table>
      </div>
    </template>
  </layout-dashboard-card>
</template>

<script>
import LayoutDashboardCard from '@/components/card/LayoutAccentCard.vue';
import Icon from '@/assets/icon_01.svg';
import { mapGetters } from 'vuex';

export default {
  name: 'CardTotalDevice',
  components: {
    LayoutDashboardCard,
  },
  data: () => ({
    icon: Icon,
  }),
  computed: {
    ...mapGetters({
      statRegistered: 'stat/registered',
    }),
  },
};
</script>

<style lang="scss" scoped>
.card-history-list {
  color: #9a9a9a;

  p {
    margin-bottom: 0;
  }

  table {
    .card-history-list-value {
      text-align: right;
      width: 48px;
    }
  }
}
</style>
